import {FC, useEffect, useState} from 'react';
import {
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow
} from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import {useOktaAuth} from '@okta/okta-react';
import {useTranslation} from 'react-i18next';

const PAGES = 5;

const BulkPaginatedTable: FC<{updateTableData: boolean}> = ({updateTableData}) => {
    const {authState} = useOktaAuth();
    const {t} = useTranslation();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(PAGES);
    const [tableData, setTableData] = useState<any[]>([]);
    const [tableLoader, setTableLoader] = useState(true);
    const countryColumns = [{
        'label': t('bulkPaginatedTable.uploadedFile')
    },
    {
        'label': t('bulkPaginatedTable.startTime')
    },
    {
        'label': t('bulkPaginatedTable.endTime')
    },
    {
        'label': t('bulkPaginatedTable.status')
    }];

    useEffect(() => {
        setTableLoader(true);
        fetch(`${process.env.REACT_APP_BACKEND_URL}/pastuploads`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Authorization': `Bearer ${authState?.accessToken?.accessToken}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .then((res) => res.json())
            .then((data) => {
                setTableData(data.message);
                setTableLoader(false);
                return null;
            }).catch((error) => {
                console.log(error);
                setTableLoader(false);
            });
    }, [authState, updateTableData]);

    const tableLoaderResult = (): JSX.Element => {
        const skeleton = (<Skeleton
            height={60}
            variant='rectangular'
            width={'auto'}
        />);

        let result = <>{t('bulkPaginatedTable.na')}</>;

        if (tableLoader) {
            result = skeleton;
        }
        return (
            <TableRow>
                <TableCell
                    align={'center'}
                    style={{
                        minWidth: 5
                    }}
                >
                    {result}
                </TableCell>
                <TableCell
                    align={'center'}
                    style={{
                        minWidth: 5
                    }}
                >
                    {result}
                </TableCell>
                <TableCell
                    align={'center'}
                    style={{
                        minWidth: 5
                    }}
                >
                    {result}
                </TableCell>
                <TableCell
                    align={'center'}
                    style={{
                        minWidth: 5
                    }}
                >
                    {result}
                </TableCell>
            </TableRow>
        );
    };

    return (
        <Card
            sx={{
                width: 'auto',
                overflow: 'hidden',
                margin: '2em 4em 2em 4em'
            }}
        >
            <TableContainer
                sx={{
                    maxHeight: 440
                }}
            >
                <Table
                    aria-label={'sticky table'}
                    stickyHeader
                >
                    <TableHead>
                        <TableRow>
                            {countryColumns.map((column, index) => (
                                <TableCell
                                    align={'center'}
                                    key={index}
                                    style={{
                                        minWidth: 5
                                    }}
                                >
                                    {column.label}
                                </TableCell>))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableData.length > 0 ? tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((rows, index) => {
                            return (
                                <TableRow
                                    hover={false}
                                    key={index}
                                    tabIndex={-1}
                                >
                                    <TableCell
                                        align='center'
                                    >
                                        {rows.upload_file}
                                    </TableCell>
                                    <TableCell
                                        align='center'
                                    >
                                        {rows.start_date}
                                    </TableCell>
                                    <TableCell
                                        align='center'
                                    >
                                        {rows.end_date}
                                    </TableCell>
                                    <TableCell
                                        align='center'
                                    >
                                        {rows.status}
                                    </TableCell>
                                </TableRow>);
                        }) : tableLoaderResult()}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                component={'div'}
                count={tableData.length}
                onPageChange={(event: any, newPage: any): void => {
                    setPage(newPage);
                }}
                onRowsPerPageChange={(event: any): void => {
                    setRowsPerPage(Number(event.target.value));
                    setPage(0);
                }}
                page={page}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[]}
            />
        </Card>
    );
};

export default BulkPaginatedTable;
